import Vue from "vue";
import FileManager from "laravel-file-manager";
import store from "@/store";

Vue.use(FileManager, { store })
